import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import EditIcon from '@mui/icons-material/Edit';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SearchIcon from '@mui/icons-material/Search';
import {
  Autocomplete,
  Badge,
  Box,
  Button,
  Checkbox,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import Popover from '@mui/material/Popover';
import {
  DataGridPro,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  useGridApiRef
} from '@mui/x-data-grid-pro';
import moment from 'moment';
import * as React from 'react';
import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { PopupComponent } from 'src/components/common/PopupComponent';
import SearchHierarchy from 'src/components/layouts/DashboardLayout/SearchHierarchy';
import { AppState, store } from 'src/store';
import { useAppSelector } from 'src/store/hooks';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import ChartComponent from './ChartComponent';
import './planning.scss';
import { CustomPagination } from 'src/util/DataTableFooter';

const PlanningComponent = (props: any) => {
  const [rows, setPlanningData] = useState<any>([]);
  const [typeList, setTypeList] = useState<any>([]);
  const [subTypeList, setSubTypeList] = useState<any>([]);
  const [artifactNameList, setArtifactNameList] = useState<any>([]);
  const [artifactNumberList, setArtifactNumberList] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);
  const [studyValue, setStudyValue] = useState<string>('');
  const [countryValue, setCountryValue] = useState<string>('');
  const [siteValue, setSiteValue] = useState<string>('');
  const [level, setSiteLevel] = useState<string>('');
  const [popoverRows, setPopoverRows] = useState<any>([]);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [alldocumentStatus, setAlldocumentStatus] = useState();
  const [pageSize, setPageSize] = useState<number>(10);
  const [page, setPage] = useState<number>(0);
  const [rowCount, setRowCount] = useState<number>(0);
  const [reason, setReason] = useState<string>();
  const [isProcessing, setProcessing] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [notify, setNotify] = useState<any>([]);
  const [anchorEl, setAnchorEl] = useState<any | null>(false);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [disableOK, setDisableOK] = useState(false);
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const [fields, setFields] = useState<any>({
    core_recomended: false
  });
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    core_recomended: false
  });
  const [configPermission, setConfigPermission] = useState(false);

  const [rowData, setRowData] = useState({
    tmf_level_map_id: '',
    tmf_doc_level: '',
    tmf_doc_study: '',
    tmf_doc_country: '',
    tmf_doc_site: '',
    tmf_artifact_number: '',
    tmf_artifact_name: '',
    isSelected: false,
    reason_selected: '',
    notify_user: '',
    updated_by: '',
    tmf_configuration_type: '',
    need_to_send_to_isf: '',
    study: '',
    country: '',
    site: ''
  });

  const docService = new DocManagementService();
  const { checkPermission } = usePermissionWrapper();
  const apiRef = useGridApiRef();
  const open = Boolean(anchorEl);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);
  const user: any = useAppSelector(state => state.user.user); //logged in user data
  const userName = `${user.firstName + ' ' + user.lastName}`;

  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }

  const [artifactName, setArtifactName] = useState();
  // count section start
  const alldocumentStatusData: any = rows.length > 0 ? [alldocumentStatus].map(item => item) : [];
  const approvalCount = alldocumentStatusData[0]?.tmf_doc_Ready_for_approval_count;
  const approvedCount = alldocumentStatusData[0]?.tmf_doc_approved_count;
  const expectedCount = alldocumentStatusData[0]?.tmf_doc_expected_count;
  const rejectedCount = alldocumentStatusData[0]?.tmf_doc_rejected_count;
  const totalCount = alldocumentStatusData[0]?.tmf_doc_total_count;
  const uploadedCount = alldocumentStatusData[0]?.tmf_doc_uploaded_count;
  const approved = approvedCount;
  const total = totalCount;
  const artifacts: any = total > 0 ? `${((approved / total) * 100).toFixed(2) || 0}` : `0`;

  const tabs = [
    {
      key: 1,
      label: <CheckCircleIcon />,
      value: 'Approved',
      style: 'approved',
      count: approvedCount
    },
    {
      key: 2,
      label: <SearchIcon />,
      value: 'Ready for Approval',
      style: 'ready-for-approval',
      count: approvalCount
    },
    {
      key: 3,
      label: <EditIcon />,
      value: 'Uploaded',
      style: 'uploaded',
      count: uploadedCount
    },
    {
      key: 4,
      label: <PendingActionsIcon />,
      value: 'Expected',
      style: 'inprogress',
      count: expectedCount
    },
    {
      key: 5,
      label: <DoNotDisturbIcon />,
      value: 'Rejected',
      style: 'rejected',
      count: rejectedCount
    }
  ];
  // count section end

  // for DataGrid columns
  const columns: GridColDef[] = [
    {
      field: 'tmf_doc_type',
      headerName: 'Type',
      flex: 1,
      minWidth: 160,
      type: 'singleSelect',
      valueOptions: typeList
    },
    {
      field: 'tmf_doc_subtype',
      headerName: 'Subtype',
      flex: 1,
      minWidth: 170,
      type: 'singleSelect',
      valueOptions: subTypeList
    },
    {
      field: 'tmf_artifact_name',
      headerName: 'Artifact Name',
      minWidth: 230,
      flex: 1,
      type: 'singleSelect',
      valueOptions: artifactNameList,
      renderCell: params => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <span className="artNameinTd">{params.formattedValue}</span>
            {params.row.sub_artifact_count !== 0 && (
              <IconButton
                aria-label="Sub-Artifact Information"
                className="datareview-help-icon"
                onClick={() => handlePopoverOpen(params.row)}
                onMouseLeave={handlePopoverClose}
              >
                <Badge badgeContent={params.row.sub_artifact_count} color="primary" className="badgeinTd"></Badge>
              </IconButton>
            )}
          </div>
        );
      }
    },
    {
      field: 'tmf_artifact_number',
      headerName: 'Artifact Number',
      minWidth: 120,
      flex: 1,
      type: 'singleSelect',
      valueOptions: artifactNumberList
    },
    {
      field: 'tmf_doc_status',
      headerName: 'Status',
      minWidth: 150,
      type: 'singleSelect',
      valueOptions: ['Uploaded', 'Ready for approval', 'Approved', 'Rejected', 'Expected', 'Sent to ISF']
    },
    {
      field: 'need_to_send_to_isf',
      headerName: 'Need to be Sent to ISF',
      minWidth: 130,
      valueOptions: ['Yes', 'No'],
      type: 'singleSelect',
      renderCell: params => {
        return (
          <Checkbox
            checked={params.row.need_to_send_to_isf === 'Yes' ? true : false}
            onClick={() => {
              sentToISF(params.row);
            }}
            disabled={configPermission === false}
          />
        );
      }
    },
    {
      field: 'tmf_configuration_type',
      headerName: 'Include in Configuration',
      flex: 1,
      minWidth: 170,
      type: 'singleSelect',
      disableExport: true,
      valueOptions: ['Core', 'Recommended'],
      renderCell: params => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Checkbox
              checked={params.row.isSelected}
              onClick={() => {
                handleClickOpenDialog(params.row);
              }}
              disabled={configPermission === false}
            />{' '}
            <Chip label={params.formattedValue} size="small" className="fontBoldChip" />
          </div>
        );
      }
    },
    {
      field: 'core_recomended',
      headerName: 'Core/Recomended',
      filterable: false,
      hideable: false,
      hide: true,
      valueGetter: (params: any) => `${params.row.core_recomended} (${params.row.isSelected})`
    }
  ];

  /* Event Handling */

  // row popover start
  const handlePopoverOpen = async (row: any) => {
    const rowId = row.id;
    const rowData = rows.find((el: any) => el.id == rowId);
    getRowData(rowData.tmf_artifact_number, rowData.study, rowData.country, rowData.site);
    setArtifactName(rowData.tmf_artifact_name);
    setAnchorEl(true);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const getRowData = async (number: string, study: string, country: string, site: string) => {
    setPopoverRows([]);
    const params = {
      module_section_related: 'TMFPlanning',
      parent_entity_related: artifactName
    };
    const res: any = await docService.getMasterDocumentArtifactBased(
      false,
      number,
      study,
      country,
      site,
      TmfLevel,
      params
    );
    if (res?.error) {
      setPopoverRows([]);
    } else {
      const docList: any = [];
      for (const doc of res.data.selected_data) {
        docList.push(doc.document_data);
      }
      setPopoverRows(docList);
    }
  };
  // row popover end

  // checkbox Dailog start
  const handleClickOpenDialog = (row: any) => {
    setDisableOK(true);
    setRowData(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    if (reason || notify) {
      setOpenConfirmExit(true);
    } else {
      setReason('');
      setNotify('');
      setOpenDialog(false);
    }
  };

  const handleChangeDiaSel = (event: any, values: any) => {
    if (values) setDisableOK(false);
    else setDisableOK(true);
    const singleUser: any = [];
    singleUser.push(values);
    setNotify(singleUser);
  };

  const handleReason = (e: any) => {
    setReason(e.target.value);
  };

  const sentToISF = async (rowData: any) => {
    const data = {
      tmf_level_map_id: rowData.tmf_level_map_id,
      tmf_doc_level: rowData.tmf_doc_level,
      tmf_doc_study: rowData.study === '--' ? '' : rowData.study,
      tmf_doc_country: rowData.country === '--' ? '' : rowData.country,
      tmf_doc_site: rowData.site === '--' ? '' : rowData.site,
      tmf_artifact_number: rowData.tmf_artifact_number,
      tmf_artifact_name: rowData.tmf_artifact_name,
      is_selected: rowData.isSelected,
      need_to_sent_isf: rowData.need_to_send_to_isf === 'Yes' ? 'No' : 'Yes',
      updated_by: userName
    };
    const params = {
      module_section_related: 'TMFPlanning',
      parent_entity_related: artifactName
    };
    const Response: any = await docService.updatePlanningField(params, data);
    if (Response.data) {
      store.dispatch(setSnackbarMessage('EDL configuration is updated successfully.', 'success'));
    } else {
      store.dispatch(setSnackbarMessage('Error in updating EDL configuration.', 'error'));
    }
    getAllPlanningData(rowData.study, rowData.country, rowData.site, 0, pageSize);
  };
  const handleConfirmDialog = async () => {
    setProcessing(true);
    const tempArray: any = [];

    rows.map((item: any) => {
      if (item.tmf_level_map_id === rowData.tmf_level_map_id) {
        tempArray.push({ ...item, isSelected: !rowData.isSelected });
      } else {
        tempArray.push(item);
      }
    });

    if (rowData) {
      const data = {
        tmf_level_map_id: rowData.tmf_level_map_id,
        tmf_doc_level: rowData.tmf_doc_level,
        tmf_doc_study: rowData.study === '--' ? '' : rowData.study,
        tmf_doc_country: rowData.country === '--' ? '' : rowData.country,
        tmf_doc_site: rowData.site === '--' ? '' : rowData.site,
        tmf_artifact_number: rowData.tmf_artifact_number,
        tmf_artifact_name: rowData.tmf_artifact_name,
        is_selected: !rowData.isSelected,
        need_to_sent_isf: rowData.need_to_send_to_isf,
        reason_selected: reason,
        notify_user: notify.length > 0 ? `${notify[0].firstName + ' ' + notify[0].lastName}` : '',
        updated_by: userName
      };
      const params = {
        module_section_related: 'TMFPlanning',
        parent_entity_related: artifactName
      };
      const Response: any = await docService.updatePlanningField(params, data);
      if (Response.data) {
        setProcessing(false);
        store.dispatch(setSnackbarMessage('EDL configuration is updated successfully.', 'success'));
        //setPlanningData(tempArray);
      } else {
        store.dispatch(setSnackbarMessage('Error in updating EDL configuration.', 'error'));
      }
    }
    setReason('');
    setNotify('');
    setOpenDialog(false);
    getAllPlanningData(rowData.study, rowData.country, rowData.site, 0, pageSize);
  };
  // checkbox Dailog start

  const getAllUsers = async () => {
    setProcessing(true);

    const response: any = await docService.getAllUsers(
      selectedStudy,
      TmfLevel,
      artifactName || '--',
      selectedCountry,
      selectedSite
    );
    if (response?.data) {
      const filtered = (response?.data || []).filter((el: any) => el.firstName !== null);
      setUsersList(filtered);
    }
    setProcessing(false);
  };

  /* Event Handling */

  const getAllPlanningData = async (study: string, country: string, site: string, from: number, size: number) => {
    setStudyValue(study);
    setCountryValue(country);
    setSiteValue(site);
    let count = 1;
    const TmfLevel =
      (study === '--' || study === '') && (country === '--' || country === '') && (site === '--' || site === '')
        ? '--'
        : (country === '--' || country === '') && (site === '--' || site === '')
        ? 'Study'
        : site === '--' && country !== '--'
        ? 'Country'
        : 'Site';
    const planningPermission =
      TmfLevel === 'Study' && checkPermission('view_study_planning')
        ? true
        : TmfLevel === 'Country' && checkPermission('view_country_planning')
        ? true
        : TmfLevel === 'Site' && checkPermission('view_site_planning')
        ? true
        : false;
    if (planningPermission === false) {
      setPlanningData([]);
      setRowCount(0);
    } else {
      setLoading(true);
      const params = {
        module_section_related: 'TMFPlanning',
        parent_entity_related: '--'
      };
      setSiteLevel(TmfLevel);

      const res: any = await docService.getAllPlanning(TmfLevel, study, country, site, params, from, size);
      const documentMetrics = res?.data?.tmf_document_metrics;
      setAlldocumentStatus(documentMetrics);
      const planArray: any = [];
      if (res.error) {
        switch (res.error?.response.status) {
          case 403:
            store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
            break;
          case 401:
            store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
            break;
          default:
            store.dispatch(setSnackbarMessage('Error in Getting Planning list.', 'error'));
        }
      } else {
        const types: Array<string> = [];
        const subTyps: Array<string> = [];
        const artifactNames: Array<string> = [];
        const artifactNumbers: Array<string> = [];

        for (const data of res.data.tmf_document_items) {
          const planObj = {
            tmf_doc_type: data.tmf_doc_type,
            tmf_doc_subtype: data.tmf_doc_subtype,
            tmf_artifact_name: data.tmf_artifact_name,
            tmf_artifact_number: data.tmf_artifact_number,
            tmf_doc_status: data.sent_to_isf_sub_status === null ? data.tmf_doc_status : data.sent_to_isf_sub_status,
            tmf_configuration_type: data.tmf_configuration_type,
            core_recomended: data.tmf_configuration_type, //for export duplicate added
            id: count++,
            tmf_level_map_id: data.tmf_level_map_id,
            isSelected: data.is_selected,
            tmf_doc_country: data.tmf_doc_country,
            tmf_doc_level: data.tmf_doc_level,
            tmf_doc_site: data.tmf_doc_site,
            tmf_doc_study: data.tmf_doc_study,
            sub_artifact_count: data.sub_artifact_count,
            need_to_send_to_isf: data.need_to_send_to_isf,
            study: study,
            country: country,
            site: site
          };
          planArray.push(planObj);
          types.push(data.tmf_doc_type);
          subTyps.push(data.tmf_doc_subtype);
          artifactNames.push(data.tmf_artifact_name);
          artifactNumbers.push(data.tmf_artifact_number);
        }
        setTypeList([...new Set(types)]);
        setSubTypeList([...new Set(subTyps)]);
        setArtifactNameList([...new Set(artifactNames)]);
        setArtifactNumberList([...new Set(artifactNumbers)]);
      }
      setPlanningData(planArray);
      setRowCount(res?.data?.record_count);
      setLoading(false);
      if (
        TmfLevel === 'Study' &&
        checkPermission('update_configuration') &&
        checkPermission('update_study_configuration')
      ) {
        return setConfigPermission(true);
      } else if (
        TmfLevel === 'Country' &&
        checkPermission('update_configuration') &&
        checkPermission('update_country_configuration')
      ) {
        return setConfigPermission(true);
      } else if (
        TmfLevel === 'Site' &&
        checkPermission('update_configuration') &&
        checkPermission('update_site_configuration')
      ) {
        return setConfigPermission(true);
      } else {
        return setConfigPermission(false);
      }
    }
  };

  //  Export custom functionality start
  const CustomToolbar = () => {
    const { userPreferedDateFormat } = usePreferedDateFormat();
    const { checkPermission } = usePermissionWrapper();

    Object.keys(fields).forEach((key: string) => {
      if (fields[key] === true) {
        delete fields[key];
      }
    });
    const removedColumns: any = Object.keys(fields);
    const columnFields = [];
    const exportFields = [];
    for (const column of columns) {
      if (column.field !== 'core_recomended') {
        columnFields.push(column.field);
      }
    }

    for (let i = 0; i <= columnFields.length - 1; i++) {
      if (removedColumns.indexOf(columnFields[i]) <= 0) {
        if (columnFields[i] === 'tmf_configuration_type') {
          exportFields.push(columnFields[i]);
          const index = exportFields.indexOf('tmf_configuration_type');
          exportFields.splice(index, 1, 'core_recomended');
        } else {
          exportFields.push(columnFields[i]);
        }
      }
    }

    const cValue = countryValue === '--' ? '' : `|${countryValue}`;
    const sValue = siteValue === '--' ? '' : `|${siteValue}`;
    const exportDateFormat = userPreferedDateFormat.includes('/')
      ? userPreferedDateFormat.replaceAll('/', '_')
      : userPreferedDateFormat.replaceAll('-', '_');
    const documentName =
      `${studyValue}${cValue}${sValue} | Planning |` +
      moment(new Date()).format(`${exportDateFormat.toUpperCase()} hh_mm A`);
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarFilterButton onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarDensitySelector onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarExport
          csvOptions={{
            fileName: documentName,
            fields: exportFields,
            disableToolbarButton: rows.length > 0 ? false : true
          }}
          disabled={!checkPermission('export_planning')}
        />
      </GridToolbarContainer>
    );
  };
  //  Export custom functionality end

  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (selectedStudy !== undefined) {
      if (pageSize === 10 || pageSize === 20 || pageSize === 30) {
        if (page * pageSize > rowCount - 1) {
          setPage(0);
          getAllPlanningData(selectedStudy, selectedCountry, selectedSite, 0, pageSize);
        } else getAllPlanningData(selectedStudy, selectedCountry, selectedSite, page * pageSize, pageSize);
      }
      getAllUsers();
    }
  }, [selectedStudy, selectedCountry, selectedSite, page, pageSize]);
  const tmfColumns = columns.filter(item => item.field !== 'need_to_send_to_isf');
  const width = TmfLevel === 'Site' ? '428px' : '248px';
  return (
    <div>
      <SearchHierarchy searchData={getAllPlanningData} />
      {isDataAvailable != null && isDataAvailable === false ? (
        <div className="no-data-class">
          <h3>No Data access available!</h3>
        </div>
      ) : (
        <>
          <Grid container className="chart-wrapper">
            {/*  <Grid sx={{ width: '196px'}} className="lineRight">
              <Grid container>
                <Grid className="chart-block">
                  <ChartComponent alldocumentStatus={alldocumentStatusData} />
                </Grid>
                <Grid className="chart-description">
                  <div className="completed green">
                  <strong>&nbsp;</strong><br />
                     <strong>{Math.round(reactDonutChartdataForIsf)}<span>%</span></strong><br /> 
                    Sent to ISF
                  </div>
                </Grid>
              </Grid>
            </Grid> */}
            <Grid sx={{ width: width, height: '78px', justifyContent: 'space-between' }}>
              <ChartComponent alldocumentStatus={alldocumentStatusData} />

              <Grid
                className="chart-description"
                sx={{ display: 'inline-block', ml: 1.5, top: '-12px', position: 'relative' }}
              >
                <div className="completed">
                  <strong>
                    {Math.round(artifacts)}
                    <span>%</span>
                  </strong>
                  <br />
                  Artifacts Complete
                </div>
              </Grid>
            </Grid>
            <Grid item xs className="chart-description">
              <ul>
                {tabs.map((item: any, index: number) => {
                  return (
                    <li className={item.style} key={index}>
                      <strong>
                        {item.label}
                        {item.count || 0}
                      </strong>{' '}
                      {item.value}
                    </li>
                  );
                })}
              </ul>
            </Grid>
          </Grid>

          <Grid container>
            <Grid md={12}>
              <div style={{ height: '71vh', width: '100%' }}>
                <DataGridPro
                  apiRef={apiRef}
                  rows={rows}
                  columns={level === 'Site' ? columns : tmfColumns}
                  disableColumnSelector={false}
                  components={{
                    NoRowsOverlay: () => (
                      <Stack height="100%" alignItems="center" justifyContent="center">
                        No rows
                      </Stack>
                    ),
                    NoResultsOverlay: () => (
                      <Stack height="100%" alignItems="center" justifyContent="center">
                        No rows
                      </Stack>
                    ),
                    Toolbar: CustomToolbar,
                    Pagination: CustomPagination
                  }}
                  //checkboxSelection
                  columnVisibilityModel={columnVisibilityModel}
                  onColumnVisibilityModelChange={(newModel: any) => {
                    setColumnVisibilityModel(newModel);
                    setFields(newModel);
                    const hideColumsArr: any = [];
                    for (const obj of columns) {
                      if (newModel[obj.field] == false) {
                        hideColumsArr.push(false);
                      } else {
                        hideColumsArr.push(true);
                      }
                    }
                  }}
                  disableSelectionOnClick
                  page={page}
                  onPageChange={newPage => setPage(newPage)}
                  pageSize={pageSize}
                  rowCount={rowCount}
                  onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                  rowsPerPageOptions={[10, 20, 30]}
                  pagination
                  paginationMode="server"
                  className="planning-grid theme-filter-spacing"
                  loading={loading}
                  initialState={{
                    sorting: {
                      sortModel: [{ field: 'tmf_artifact_number', sort: 'asc' }]
                    }
                  }}
                  // componentsProps={{
                  //   cell: {
                  //     onMouseEnter: handlePopoverOpen,
                  //     onMouseLeave: handlePopoverClose
                  //   }
                  // }}
                />
                {popoverRows.length > 0 && (
                  <Popover
                    sx={{
                      pointerEvents: 'none'
                    }}
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: 'center',
                      horizontal: 'center'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left'
                    }}
                    onClose={handlePopoverClose}
                  >
                    <Box sx={{ flexGrow: 1, p: 2 }} className="subArtifactPopContent">
                      <TableContainer>
                        <Table sx={{ minWidth: 540 }} size="small" aria-label="Sub-artifacts details">
                          <TableHead>
                            <TableRow>
                              <TableCell>Document Name</TableCell>
                              <TableCell width={90}>Status</TableCell>
                              <TableCell>Version</TableCell>
                              <TableCell>Created By</TableCell>
                              <TableCell>Created On</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {popoverRows.length > 0 &&
                              popoverRows.map((row: any, index: number) => (
                                <TableRow key={index}>
                                  <TableCell>{row.tmf_document_name}</TableCell>
                                  <TableCell>{row.tmf_doc_status}</TableCell>
                                  <TableCell>
                                    <Chip
                                      label={`Ver ${parseFloat(row.tmf_doc_version_number).toFixed(1)}`}
                                      size="small"
                                      variant="outlined"
                                    />
                                  </TableCell>
                                  <TableCell>{row.tmf_doc_created_by}</TableCell>
                                  <TableCell>
                                    {moment(new Date(row.created_on)).format(userPreferedDateFormat.toUpperCase())}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Popover>
                )}
              </div>
            </Grid>
          </Grid>

          <PopupComponent open={openDialog} maxWidth="sm">
            <DialogContent className="ConfirmDialog">
              {isProcessing && <LinearProgress />}
              <Typography variant="h6" component="div" sx={{ mb: 1 }}>
                Confirm
              </Typography>
              <DialogContentText sx={{ mb: 1 }}>
                {rowData.tmf_configuration_type === 'Recommended'
                  ? rowData.isSelected
                    ? 'Are you sure you want to remove this recommended artifact from the configuration? If so, please provide a reason.'
                    : 'Are you sure you want to add this recommended artifact to the configuration? If so, please provide a reason.'
                  : rowData.isSelected
                  ? 'Are you sure you want to remove this core artifact from the configuration? If so, please provide a reason'
                  : 'Are you sure you want to add this core artifact to the configuration? If so, please provide a reason'}
              </DialogContentText>
              <TextField
                autoFocus
                id="name"
                label="Reason"
                type="text"
                fullWidth
                variant="standard"
                inputProps={{ maxLength: 250 }}
                onChange={e => handleReason(e)}
                value={reason?.trimLeft()}
                disabled={isProcessing}
              />
              <FormControl fullWidth variant="standard" sx={{ my: 3 }}>
                <Autocomplete
                  disabled={isProcessing}
                  id="tags-standard-users"
                  options={usersList}
                  getOptionLabel={(option: any) =>
                    option.firstName + ' ' + option.lastName + ' (' + option?.email + ')'
                  }
                  onChange={handleChangeDiaSel}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Notify System Admin for Review"
                      placeholder="Users"
                    />
                  )}
                />
              </FormControl>
            </DialogContent>
            <DialogActions sx={{ mb: 0.5 }}>
              <Button onClick={handleCloseDialog} className="grey-btn">
                Cancel
              </Button>
              <Button disabled={isProcessing} onClick={handleConfirmDialog}>
                Ok
              </Button>
            </DialogActions>
          </PopupComponent>
        </>
      )}
      <div>
        <PopupComponent
          open={openConfirmExit}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
          child={true}
        >
          <DialogTitle id="alert-dialog-title">
            <b>Confirm Exit</b>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Changes you made will not be saved. Are you sure you want to exit before saving your changes?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfirmExit(false);
              }}
              className="grey-btn"
            >
              CLOSE
            </Button>
            <Button
              onClick={() => {
                setOpenDialog(false);
                setOpenConfirmExit(false);
                setReason('');
                setNotify('');
              }}
            >
              EXIT
            </Button>
          </DialogActions>
        </PopupComponent>
      </div>
    </div>
  );
};
export default memo(PlanningComponent);
